import initialState from './initialState';
import {
  RESET_WORKING_SHIFT_GROUPS,
  FETCH_WORKING_SHIFT_GROUPS_INIT,
  FETCH_WORKING_SHIFT_GROUPS_SUCCESS,
  FETCH_WORKING_SHIFT_GROUPS_FAILURE
} from '../../../actions/common/working_shift_groups/types';

export default function working_shift_groups(state = initialState, action) {
  switch (action.type) {
    case FETCH_WORKING_SHIFT_GROUPS_INIT:
      return{
        ...state,
        filter: [],
        loading: true
      };
    case FETCH_WORKING_SHIFT_GROUPS_SUCCESS:
      return{
        ...state,
        filter: action.payload.data,
        loading: false,
        status: action.payload.status
      };
    case FETCH_WORKING_SHIFT_GROUPS_FAILURE:
      return{
        ...state,
        filter: [],
        loading: false,
        status: 401
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/common/working_shift_groups/index.js